import React, { useState, useEffect, useRef } from 'react';
import './About.css';
import QualifiersSection from './QualifiersSection'; // Import QualifiersSection
import RequestServiceForm from './RequestServiceForm'; // Import RequestServiceForm
import Footer from './Footer'; // Import Footer

const About = ({ formRef }) => { // Accept formRef as prop
  const aboutSectionRef = useRef(null);
  const animationTriggerRef = useRef(null); // Ref for the animation trigger
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (animationTriggerRef.current) {
        const { top, height } = animationTriggerRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        // Calculate progress based on the scroll within the animation trigger
        const progress = Math.max(0, Math.min(1, (-top) / (height - windowHeight)));
        setScrollProgress(progress);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Toggle fixed positioning for the about-section while the flip animation runs
  useEffect(() => {
    const el = aboutSectionRef.current;
    if (!el) return;
    const during = scrollProgress > 0 && scrollProgress < 0.999; // hold fixed until just before complete
    const after = scrollProgress >= 0.999; // park at end to avoid flicker/disappear

    el.classList.toggle('about-fixed', during);
    el.classList.toggle('about-fixed-end', after);
    setIsFixed(during);
  }, [scrollProgress]);

  const handleBookNowClick = () => {
    if (formRef.current) {
      const navbarHeight = 60; // Height of the fixed navbar
      const elementPosition =
        formRef.current.getBoundingClientRect().top +
        window.pageYOffset;
      const offsetPosition = elementPosition - navbarHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  // Calculate flip effect based on scrollProgress
  const flipRotation = scrollProgress * 180; // 0 to 180 degrees
  const cardOpacity = scrollProgress; // 0 to 1

  return (
    <div className="about-page">
      <div className="about-animation-trigger" ref={animationTriggerRef}>
        <section className="about-section" ref={aboutSectionRef}>
          <div className="about-image-column">
            <img src="/images/chris-hero-pose.png" alt="Chris" className="about-image" />
          </div>
          <div className="about-logo-column">
            <div className="logo-flip-container">
              {/* Sizing probe to make the container match the logo's rendered size */}
              <img
                src="/01_MVE_Main_Logo_Website.png"
                alt=""
                aria-hidden="true"
                className="logo-sizing-probe"
              />
              <div className="logo-front" style={{ transform: `rotateX(${flipRotation}deg)` }}>
                <img src="/01_MVE_Main_Logo_Website.png" alt="MegaVolt Electric Logo" className="about-logo" />
              </div>
              <div className="logo-back" style={{ transform: `rotateX(${180 + flipRotation}deg)`, opacity: cardOpacity }}>
                <div className="about-card">
                  <h2>About Us</h2>
                  <p>
                    Although Megavolt Electric was only founded in 2021, we believe our extensive experience, work ethic, and focus on customer service will serve Calgary and its neighbours in the future. We bring over 40 years of electrical expertise and customer service experience to support our goals of being Calgary's most trusted Electrical service company. Every customer at Megavolt Electric will be treated with respect and kindness; we will listen to you and do our best to ensure that the experience is meaningful and beneficial.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <QualifiersSection onBookNowClick={handleBookNowClick} />
      {/* Guarantees section removed */}
      <RequestServiceForm ref={formRef} showCloseButton={false} />
      <Footer />
    </div>
  );
};

export default About;
